import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export const NotFoundPage = () => {
	const navigate = useNavigate();

	return (
		<div className="flex items-center justify-center min-h-[75vh] px-4">
			<div className="flex flex-col items-center gap-4 p-6 bg-white rounded-md shadow-lg max-w-md w-full">
				<XCircle className="h-12 w-12 text-blue-500" />
				<h1 className="text-2xl font-bold text-blue-500">
					404 - Page Not Found
				</h1>
				<p className="text-center text-sm text-gray-500">
					Sorry, we couldn’t find the page you were looking for.
				</p>
				<Button
					onClick={() => navigate('/')}
					className="mt-2 bg-blue-500 text-white hover:bg-blue-600 cursor-pointer"
				>
					Go to Home
				</Button>
			</div>
		</div>
	);
};
